export default {
    fields: [
        {
            key:"_selected",
            label: "",
            sortable: false,
            filter:false,
            fixed: true,
            _filter: false,
            _style: "vertical-align: top;",
        },
        {
            key: "LeadId",
            label: "#",
            sorter: true,
            filter: false,
            _filter: true,
            fixed: true,
            active: true
        },
        {
            key: "Email",
            label: "Email",
            sorter: true,
            filter: false,
            _filter: true,
            active: true
        },
        {
            key: "Phone",
            label: "Phone",
            sorter: true,
            filter: false,
            _filter: true,
            active: true
        },
        {
            key: "FirstName",
            label: "First Name",
            sorter: true,
            filter: false,
            _filter: false,
            active: true
        },
        {
            key: "LastName",
            label: "Last Name",
            sorter: true,
            filter: false,
            _filter: false,
            active: true
        },
        {
            key: "Cp",
            label: "Cp",
            sorter: true,
            filter: false,
            _filter: true,
            active: false
        },
        {
            key: "Origin",
            label: "origin",
            sorter: true,
            filter: false,
            _filter: true,
            active: true
        },
        {
            key: "CreatedAt",
            label: "Created At",
            sorter: true,
            filter: false,
            _filter: false,
            active: true
        },
        {
            key: "State",
            label: "State",
            sorter: true,
            filter: false,
            _filter: true,
            active: true
        }

    ],
    allFields: [],
    items: [],
    order: "desc",
    orderField: "id",
    rows: 10,
    page: 1,
    total_pages: 0,
    loading: true,
    pagination: true,
    sorter: true,
    responsive: true,
    columnFilter: {
        external: true,
        lazy: true
    },
    columnFilterValue: {},
    itemsPerPageSelect:{
        values:[5, 10, 20, 50, 100],
    },
    dateFieldFilter: "CreatedAtDate",
    orderField: "LeadId",
    matchResponse: "data.items",
    matchResponseCurrentPage: "data.currentPage",
    matchResponsePages: "data.pages",
}